import axios from "axios";

// Plain axios — no auth header; these are public endpoints
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export const getSignSession = (token) =>
    axios.get(`${API_BASE}/Sign/${token}`);

// Customer-only submit. The agent no longer signs via this public link — they sign
// from the authenticated sale page (Sales/AgentSign).
export const submitSignature = (token, { signaturePng, signedByName }) =>
    axios.post(`${API_BASE}/Sign/${token}`, { signaturePng, signedByName });
